//for making width equal to height in recommended section
window.addEventListener('resize', function(event) {
    widthEqualHeight();
}, true);

function widthEqualHeight(){
    let width = window.innerWidth;
    if(width<768){
        var el1 = document.querySelectorAll(".section-featured-blog .custom_grid .swiper-container[data-first-post-big=true] .swiper-slide .rimage-wrapper");
        for(var i = 0; i < el1.length; i++)
        {
            el1[i].style.height = getComputedStyle(el1[i]).width;
        }  
    }
    else{
        var el2 = document.querySelectorAll(".section-featured-blog .custom_grid .swiper-container[data-first-post-big=true] .swiper-slide.swiper-slide--rest .rimage-wrapper");
        
        for(var i = 0; i < el2.length; i++)
        {
            el2[i].style.height = getComputedStyle(el2[i]).width;
        }  
        
        $(window).bind("load", function() {
            var el3 = document.querySelector(".section-featured-blog .custom_grid .swiper-container[data-first-post-big=true] .swiper-slide.swiper-slide--first");
            var el4 = el3.parentNode.parentNode;
            el3.style.height = el4.offsetHeight+'px';
         });
    }
}

widthEqualHeight();
